module.exports = __webpack_public_path__ + "static/media/pdfs.d3eace18.svg";